import { useEffect } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { useToast } from "@/components/ui/use-toast";

export function PWAUpdater() {
  const { toast } = useToast();

  const {
    needRefresh: [needRefresh],
    offlineReady: [offlineReady],
    updateServiceWorker,
  } = useRegisterSW();

  useEffect(() => {
    if (offlineReady) {
      toast({
        title: "Offline ready",
        description: "Noche Loco works even without internet.",
      });
    }
  }, [offlineReady, toast]);

  useEffect(() => {
    if (needRefresh) {
      toast({
        title: "Update available",
        description: "A new version is ready. Updating...",
      });
      setTimeout(() => updateServiceWorker(true), 1000);
    }
  }, [needRefresh, toast, updateServiceWorker]);

  return null;
}
